import mixpanel from 'mixpanel-browser';

mixpanel.init('b42539241f75b6d093567e63ddb5a6b3');

const envCheck = process.env.NODE_ENV !== 'development';

const actions = {
  identify: (id) => {
    if (envCheck) mixpanel.identify(id);
  },
  alias: (id) => {
    if (envCheck) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (envCheck) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (envCheck) mixpanel.people.set(props);
    },
  },
};

export const Mixpanel = actions;
